import type { ReactNode } from "react";

import { Card, CardContent } from "@/components/ui/card";

type Props = {
  title: string;
  value: string | number;
  icon?: ReactNode;
  tone?: "default" | "success" | "warning" | "danger";
};

const toneClasses = {
  default: "text-white",
  success: "text-emerald-400",
  warning: "text-amber-400",
  danger: "text-red-400",
};

export function StatCard({ title, value, icon, tone = "default" }: Props) {
  return (
    <Card>
      <CardContent className="p-5">
        <div className="flex items-center justify-between">
          <p className="text-sm text-slate-400">{title}</p>
          {icon && <div className="text-slate-400">{icon}</div>}
        </div>

        <p className={`mt-4 text-3xl font-bold ${toneClasses[tone]}`}>
          {value}
        </p>
      </CardContent>
    </Card>
  );
}